<form class="grid grid-nogutter p-fluid text-center" [formGroup]="form" (submit)="submitForm()">
    <h3 class="col-12 my-2 px-2">
        Üdvözöljök a Debreceni Egyetem időpontfoglaló rendszerében! A regisztrációs adatok megadásánál figyeljen arra,
        hogy olyan
        e-mail címet adjon meg, amelyet rendszeresen hasnzál, ugyanis azon keresztül történik a kommunikáció!
    </h3>
    <h5 class="col-12 mb-6 px-2">A név és a NEPTUN kód automatikusan töltődik a Neptun rendszeréből, ha valamilyen eltérést
        lát, kérjük regisztráció előtt jelezze!</h5>
    <div class="grid col-8 md:col-4 col-offset-2 md:col-offset-4 card text-left align-items-center">
        <label class="font-semibold col-12 md:col-4 pb-0">Név</label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" [value]="'Kiss János'" [readonly]="false"
                   formControlName="name"/>
        </div>
        <label class="font-semibold col-12 md:col-4 pb-0">NEPTUN kód</label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" [value]="'NJ6RFQ'" [readonly]="false"
                formControlName="neptunCode"/>
        </div>
        <input type="email" style="position:absolute; opacity:0; height:0; border:0;">
        <input type="password" style="position:absolute; opacity:0; height:0; border:0;">
        <label class="font-semibold col-12 md:col-4 pb-0">E-maiI cím
            @if (form.get('email')?.invalid && (form.get('email')?.dirty)) {
                <i class="pi pi-exclamation-triangle" [ngStyle]="{float: 'right', fontSize: '1.5rem', color: '#C62828'}"
                   [pTooltip]="'A mező kitöltése kötelező!'"></i>
            }</label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" type="text"
                   formControlName="email"/>
        </div>
        <label class="font-semibold col-12 md:col-4 pb-0">Jelszó
            @if (form.get('password')?.invalid && (form.get('password')?.dirty)) {
                <i class="pi pi-exclamation-triangle" [ngStyle]="{float: 'right', fontSize: '1.5rem', color: '#C62828'}"
                   [pTooltip]="'A mező kitöltése kötelező!'"></i>
            }</label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" [type]="'password'"
                   formControlName="password"/>
        </div>
        <label class="font-semibold col-12 md:col-4 pb-0">Jelszó újra
            @if (form.get('confirmPassword')?.invalid && (form.get('confirmPassword')?.dirty)) {
                <i class="pi pi-exclamation-triangle" [ngStyle]="{float: 'right', fontSize: '1.5rem', color: '#C62828'}"
                   [pTooltip]="'A jelszavak nem egyeznek!'"></i>
            }</label>
        <div class="col-12 md:col-8 flex-auto">
            <input pInputText autocomplete="off" [fluid]="true" [type]="'password'" formControlName="confirmPassword"/>
        </div>
        <div class="col-12 md:col-6">
            <button pButton class="p-button-outlined" label="Hibás adatok jelentése"
                    type="button"></button>
        </div>
        <div class="col-12 md:col-6">
            <button pButton label="Regisztráció"
                    type="submit"></button>
        </div>
    </div>
</form>

<p-toast #toast position="center" key="center">
    <ng-template let-message #message>
        <div class="grid text-center">
            <div class="col-12 font-medium text-2xl mb-3">{{ message.summary }}</div>
            <div class="col-12 font-medium text-lg">{{ message.detail }}</div>
            <div class="col-12 font-medium">
                <span class="inline-block align-content-center" [ngStyle]="{padding: '1rem', borderRadius: '50%',
                background: message.severity === 'success' ? '#43A047' : '#E53935', color: 'white'}">
                    <i class="pi" [ngStyle]="{fontSize: '2rem'}"
                    [ngClass]="message.severity === 'success' ? 'pi-envelope' : 'pi-times-circle'"></i>
                </span></div>
            <div class="col-12">
                <button pButton
                        [label]="'OK'" type="button" (click)="clearToasts()"></button>
            </div>
        </div>
    </ng-template>
</p-toast>
